import * as ENV from "@/config.js";

/**
 * Normalise venue labels so these match:
 * - "Book_Free_Child_Restraint_Fitting"
 * - "Book Free Child Restraint Fitting"
 * Case-insensitive; underscores and spacing collapsed.
 */
export function normalizeVenueLabel(value) {
  if (value == null) return "";
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * True when the given venue type (from UI, query, or session) matches
 * VUE_APP_EVENTS_VENUE_NAME from env for the current build.
 */
export function isEventsVenueVenueType(venueType) {
  const configured = ENV.VUE_APP_EVENTS_VENUE_NAME;
  if (!configured || !String(configured).trim()) return false;
  const a = normalizeVenueLabel(venueType);
  const b = normalizeVenueLabel(configured);
  return a.length > 0 && a === b;
}
